/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { jobsDownload } from "../../funcs/jobsDownload.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1JobsJobIdDownloadRequest$inboundSchema,
};

export const tool$jobsDownload: ToolDefinition<typeof args> = {
  name: "jobs_download",
  description: `Download job results as CSV

This endpoint downloads the results of a Google Maps scraping job as CSV`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await jobsDownload(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
